var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home mainWidth",class:{phone:_vm.$store.state.isEquipment === 'phone'}},[_c('EmphasisShow'),_c('Information'),_c('Interview'),_c('Newsstand'),_c('Shiping',{attrs:{"sendText":_vm.sendText}}),_c('Scholar'),_c('Subject'),_c('Achievement'),_c('Bema'),_c('Reality'),_c('Book')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }